<template>
  <footer class="py-4 w-full bg-[#474747]">
    <div class="container mx-auto px-4">
      <p class="text-xl mb-2 text-center text-white">Grupo Convergencia</p>
      <p class="text-sm text-center text-white">(+54) 011-4345-3036</p>
      <p class="text-sm text-center text-white">eventos@convergencia.com</p>
      <p class="text-xl mt-3 text-center text-white">Más información</p>
      <p class="text-sm text-center text-white">Ceclila Cambareri | +54 9 11 6400-2001</p>
      <p class="text-sm text-center text-white">Fernando Puga | +54 9 11 6400-1997</p>


    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>